module.exports = __webpack_public_path__ + "static/media/user-color.ee216bb2.svg";